import { BannerDataType } from './bannersTypes';

interface Fallbacks {
  [key: string]: BannerDataType;
}

const fallbacks: Fallbacks = {
  ['add-ons-closed']: {
    cta: 'GO TO SHOP',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            text: 'In the meantime, check out our amazing products in the Shop!',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Add-Ons is Closed for the Season',
  },
  ['add-ons-closed-select-user']: {
    cta: 'GO TO SHOP',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            text: 'In the meantime, check out our amazing products in the Shop!',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Add-Ons is Closed for the Season',
  },
  ['add-ons-closed-trial-user']: {
    cta: 'UPGRADE TO ANNUAL',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            text: 'In the meantime, check out our amazing products in the Shop!',
            type: 'text',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            bold: true,
            text: 'Want to shop the next sale?',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Add-Ons is Closed for the Season',
  },
  ['add-ons-closed-expired-user']: {
    cta: 'REACTIVATE NOW',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            bold: true,
            text: 'Want to shop the next sale?',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Add-Ons is Closed for the Season',
  },
  ['add-ons-closed-club-user']: {
    cta: 'ACTIVATE MY MEMBERSHIP',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            text: 'In the meantime, check out our amazing products in the ',
            type: 'text',
          },
          {
            url: 'https://fabfitfun.com/shop',
            type: 'link',
            children: [
              {
                text: 'Shop',
                type: 'text',
              },
            ],
          },
          {
            text: '!',
            type: 'text',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            bold: true,
            text: 'Want to shop the next sale?',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Add-Ons is Closed for the Season',
  },
  ['add-ons-closed-cancelled-with-zero-boxes-user']: {
    cta: 'REACTIVATE NOW',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            bold: true,
            text: 'Want to get access when it does open?',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Add-Ons is Closed for the Season',
  },
  ['add-ons-closed-customer-user']: {
    cta: 'UPGRADE TO ANNUAL',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/add_ons_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            text: 'In the meantime, check out our amazing products in the Shop!',
            type: 'text',
          },
        ],
      },
      {
        type: 'paragraph',
        children: [
          {
            bold: true,
            text: 'Want early access to sales and Customization?',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Add-Ons is Closed for the Season',
  },
  ['customization-closed']: {
    cta: 'VIEW MY BOX',
    imageDesktop:
      'https://scontent01.fabfitfun.com/gtb/cdn/customization_closed_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/customization_closed_banner_mobile.jpeg',
    subtitle: undefined,
    title: 'Customization is Closed for the Season',
  },
  ['flash-sale-closed']: {
    cta: '',
    imageDesktop: 'https://scontent01.fabfitfun.com/gtb/cdn/flash_sale_banner_desktop.jpeg',
    imageMobile: 'https://scontent01.fabfitfun.com/gtb/cdn/flash_sale_banner_mobile.jpeg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            text: 'View our ',
            type: 'text',
          },
          {
            url: 'https://get.fabfitfun.com/upcoming/',
            type: 'link',
            children: [
              {
                text: 'Events Calendar',
                type: 'text',
              },
            ],
          },
          {
            text: ' for upcoming sales.',
            type: 'text',
          },
        ],
      },
    ],
    title: 'Check Back Soon for Our Next Sale!',
  },
  ['homepage']: {
    imageDesktop: 'https://scontent01.fabfitfun.com/homepage/cdn/homepage_desktop.jpg',
    title: 'Deals for Days',
    cta: 'SHOP NOW',
    imageMobile: 'https://scontent01.fabfitfun.com/homepage/cdn/homepage_mobile.jpg',
    subtitle: [
      {
        type: 'paragraph',
        children: [
          {
            text: 'Browse The Shop where Members can earn 5% in FFF Rewards on qualifying purchases (terms apply).',
            type: 'text',
          },
        ],
      },
    ],
  },
};

export default fallbacks;
